import { z } from 'zod/v3';

export const InputProcessingBatchSchema = z.object({
  id: z.number(),
  batchTypeId: z.number().nullable(),
  statusId: z.number().nullable(),
  sourceDataVersionId: z.number().nullable(),
  fileName: z.string().nullable(),
});
